{
  "limits": {
    "overlay": {
      "title": {
        "pdfExports": "Export plan to PDF",
        "importingLayers": "Import layers",
        "teamWorkspace": "Team Workspace",
        "team": "Create teams",
        "maximumUsers": "Add users",
        "siteMaps": "Add sitemaps",
        "FlowRate": "Analysis tools",
        "Capacity": "Analysis tools",
        "layer3DTypes": "Create 3D layer",
        "iconAndModelUploads": "Upload 3D/icon components",
        "attributeDataExport": "Export to Excel",
        "sharedLinks": "Generate link",
        "imagesOnModels": "Custom Images on Models"
      },
      "content": {
        "text1": {
          "pdfExports": "You currently do not have access to export the plan to PDF. Upgrade to work on plans collaboratively with other team members.",
          "importingLayers": "You currently do not have access to import layers from other plans. Upgrade to work on plans collaboratively with other team members.",
          "teamWorkspace": "You currently do not have access to the team workspace. Upgrade to work on plans collaboratively with other team members.",
          "team": "You currently do not have access to create teams in your current plan. Upgrade to work on plans collaboratively with other team members.",
          "maximumUsers": "You currently do not have access to add more users. Upgrade to work on plans collaboratively with other team members.",
          "maxTeamMaps": "Oh no! It looks like you have run out of plans for your plan. Upgrade to work on plans collaboratively with other team members.",
          "siteMaps": "You currently do not have access to upload sitemaps in your current plan. Upgrade to integrate CAD drawings into your plans.",
          "FlowRate": "You currently do not have access to the flow rate analysis tool in your current plan. Upgrade to work on plans collaboratively with other team members.",
          "Capacity": "You currently do not have access to the capacity analysis tool in your current plan. Upgrade to work on plans collaboratively with other team members.",
          "customLogo": "Upgrade to add your own logo and branding",
          "layer3DTypes": "You currently do not have access to create 3D layers in your current plan. Upgrade to work on plans collaboratively with other team members.",
          "iconAndModelUploads": "You currently do not have access to upload 3D/icon components in your current plan. Upgrade to work on plans collaboratively with other team members.",
          "customLayer": "Your current plan does not allow you to create custom layers. Upgrade to create more plans collaboratively with other team members.",
          "attributeDataExport": "You currently do not have access to export to Excel. Upgrade to work on plans collaboratively with other team members.",
          "sharedLinks": "You currently do not have access to the share the map. Upgrade to work on maps collaboratively with other team members.",
          "sso": "Upgrade your plan to configure Sso",
          "imagesOnModels": "You currently do not have access to upload custom images onto your models. Upgrade to work on plans collaboratively with other team members."
        },
        "text2": "Here are some of the benefits of an upgrade:",
        "professional": {
          "1": "Shared workspace for your team",
          "2": "Customisable and flexible layers and icons",
          "3": "CAD integration and PDF exports"
        }
      }
    }
  }
}